import { useState, useCallback, useMemo } from 'react';
import {
  dateToMidnightUTCString,
  dateToMidnightUTCObject
} from '~/modules/common/dates/convert';
import { useSessionStorage } from '~/modules/common/hooks/useSessionStorage';

const useDateState = ({ initialValue, sessionStorageKey }) => {
  const [date, setDate] = useState(initialValue);

  const {
    storedValue: dateFromSessionStorage,
    setValue: setDateInSessionStorage
  } = useSessionStorage(sessionStorageKey, null);

  const dateValue = useMemo(() => {
    if (!sessionStorageKey) return null;

    return dateFromSessionStorage
      ? dateToMidnightUTCObject(dateFromSessionStorage)
      : initialValue;
  }, [sessionStorageKey, dateFromSessionStorage, initialValue]);

  const setValue = useCallback(
    value => setDateInSessionStorage(dateToMidnightUTCString(value)),
    [setDateInSessionStorage]
  );

  if (sessionStorageKey) {
    return [dateValue, setValue];
  }

  return [date, setDate];
};

export default useDateState;
